import React, { useState, useEffect } from "react";
import ReactModal from 'react-modal';
import { useCookies } from 'react-cookie';
import * as Constants from "../helpers/constants"

ReactModal.setAppElement('#___gatsby');
const Calendly = ({ show, eventUrl, onCloseHandler }) => {

  const [cookies] = useCookies([Constants.PERSIST_COOKIE_GTM_CAMPAIGN_URL]);
  const [finalEventUrl, setFinalEventUrl] = useState(eventUrl)

  useEffect(() => {
    try {
      // this hook help us to determine the final calendly event url with the UTM params
      // this hook will listen for change in cookies and eventUrl 
      // since the eventUrl can be with/without querystring (?)
      // we need to parse both the __gtm_campaign_url and eventUrl to ensure we append
      // the UTM params post the "?" char  

      // read UTM params from the __gtm_campaign_url, this will be set by GTAG
      let gtmCampaignUrl = cookies[Constants.PERSIST_COOKIE_GTM_CAMPAIGN_URL]
      if (gtmCampaignUrl) {
        gtmCampaignUrl = decodeURIComponent(gtmCampaignUrl)
        const utmParams = gtmCampaignUrl.split("?")[1]
        if (utmParams && utmParams.trim()) {
          const _eventUrl = eventUrl.split("?")
          const _eventUrlParams = _eventUrl[1]
          if (_eventUrlParams && _eventUrlParams.trim()) {
            // both the query param exists
            setFinalEventUrl(`${_eventUrl[0]}?${_eventUrlParams}&${utmParams}`)
          } else {
            // only urm params exist
            setFinalEventUrl(`${_eventUrl[0]}?${utmParams}`)
          }
        }
      }
    } catch (e) { }
  }, [cookies, eventUrl])

  return (
    <div>
      <ReactModal
        isOpen={show}
        onRequestClose={onCloseHandler}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        preventScroll={true}
        style={{
          overlay: {
            zIndex: 2147483601,
            background: '#000000cf'
          },
          content: {
            background: '#ffffff30',
            border: '0px',
            inset: '0px'
          }
        }}
      >
        <div>
          <button onClick={(e) => {
            e.stopPropagation()
            onCloseHandler()
          }} style={{
            float: 'right', border: '0px', backgroundColor: '#ffa700b5',
            width: '30px', top: '6px', right: '20px', position: 'absolute',
            zIndex: 99999999
          }}>
            <span aria-hidden="true" className="fs-3">&times;</span>
          </button>
          <iframe
            title="Calendly popup"
            src={`${finalEventUrl}`}
            style={{ height: "100%", width: "100%", position: "absolute", top: 0, left: 0 }}
          ></iframe>
        </div>
      </ReactModal>
    </div >
  );
}

export default Calendly;

